<template>
  <div id="alert" class="alert hide">
    <span>{{ message }}</span>
  </div>
</template>

<script setup>
import { defineProps, onMounted } from 'vue';

const props = defineProps({
  message: String
})

onMounted(() => {
    document.getElementById("alert").className = "alert alert__show alert__showAlert";
    setTimeout(() => {
      document.getElementById("alert").className = "alert alert__hide alert__showAlert";
    }, 5000)
  }
)
</script>
